export const orderFeaturedProducts = (products, order) =>
    products.sort((a, b) => order.indexOf(a.handle) - order.indexOf(b.handle));
    